import * as actionTypes from "./actionTypes";
import vediAPI from "../../utils/vedi-api/vediAPI";

const setServicios = (servicios) => ({
  type: actionTypes.SET_SERVICIOS,
  servicios,
});

const setFavoritos = (favoritos) => ({
  type: actionTypes.SET_FAVORITOS,
  favoritos,
});

const setServiciosFailed = (errorMsg) => ({
  type: actionTypes.SET_SERVICIOS_FAILED,
  errorMsg,
});

export const setSelectedServicio = (selectedServicio) => ({
  type: actionTypes.SET_SELECTED_SERVICIO,
  selectedServicio,
});

export const setServicioBuscado = (servicioBuscado) => ({
  type: actionTypes.SET_SERVICIO_BUSCADO,
  servicioBuscado,
});

export const fetchServicios = (isDevMobile = 0) => {
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.get(`v5/AplicacionPanel`, {
        headers: {
          "--Movil": isDevMobile,
        },
      });

      if (!data.ok) {
        throw new Error(data.error);
      }

      let listadoFavoritos = [];
      try {
        listadoFavoritos = await dispatch(getFavoriteServices());
      } catch (favError) {
        console.error("Error al obtener favoritos:", favError);
      }

      const listadoServicios = data.return;

      const serviciosOrdenados = ordenarServicios(
        listadoServicios,
        listadoFavoritos
      );

      dispatch(setFavoritos(listadoFavoritos));
      dispatch(setServicios(serviciosOrdenados));
    } catch (error) {
      console.error("Error data de servicios:", error.message || error);
      dispatch(setServiciosFailed(error.message || "Error desconocido"));
    }
  };
};

const ordenarServicios = (servicios, favoritos) => {
  if (!favoritos || favoritos.length === 0) {
    return servicios;
  }

  const serviciosFavoritos = servicios.filter((servicio) =>
    favoritos.some((favorito) => favorito.idAplicacion === servicio.id)
  );

  const serviciosNoFavoritos = servicios.filter(
    (servicio) =>
      !favoritos.some((favorito) => favorito.idAplicacion === servicio.id)
  );

  return [...serviciosFavoritos, ...serviciosNoFavoritos];
};

export const fetchEscribanoToken = () => {
  return async (dispatch) => {
    try {
      const resp = await vediAPI.post("v3/Usuario/TokenEscribanos");
      return resp.data.return.access_token;
    } catch (e) {
      console.error("[action] data tkn login error(?", e);
    }
  };
};

export const getActivoEscribano = (cuil, tk) => {
  return async (dispatch) => {
    try {
      const resp = await vediAPI.get("v3/Usuario/ActivoEscribanos", {
        headers: {
          "--Cuil": cuil,
          "--TokenEsc": tk,
        },
      });
      const objResp = JSON.parse(resp.data.return);
      return objResp[0].estado;
    } catch (e) {
      console.error("[action] data activo esc error(?", e);
    }
  };
};

export const fetchEscTknLogin = () => {
  return async (dispatch) => {
    try {
      const resp = await vediAPI.post("v3/Usuario/TokenTributario");

      return resp.data.return.access_token;
    } catch (e) {
      console.error("[action] data tkn login error(?", e);
    }
  };
};

export const getInfoNot = (idNot, tk) => {
  return async (dispatch) => {
    try {
      const resp = await vediAPI.get(`v3/Usuario/InformeNotarial`, {
        headers: {
          "--TokenTributario": tk,
          "--Identificador": idNot,
        },
      });

      return resp.data.return;
    } catch (e) {
      console.error("Error getInfoNot", e);
    }
  };
};

export const getLastServicesUsed = () => {
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.get(
        "v3/Usuario/AplicacionesUltimasIngresadas"
      );

      if (!data?.ok) {
        console.error(
          data.error || "Error desconocido en la respuesta del servidor"
        );
      }

      if (!Array.isArray(data.return) || data.return.length === 0) return;

      return data.return;
    } catch (error) {
      console.error("Error en getLastServicesUsed:", error.message);
      return Promise.reject(error);
    }
  };
};

export const getFavoriteServices = () => async (dispatch) => {
  try {
    const { data } = await vediAPI.get("v3/Usuario/AplicacionesFavoritas");

    if (!data?.ok) {
      throw new Error(
        data.error || "Error desconocido en la respuesta del servidor"
      );
    }

    if (!data.return || !Array.isArray(data.return.aplicaciones)) {
      throw new Error(
        "Todavía no ha asignado ninguna aplicación como favorita."
      );
    }

    return data.return.aplicaciones;
  } catch (error) {
    console.error("Error en getFavoriteServices:", error.message);
    throw error;
  }
};

export const fetchFavoriteService = (numeroApp) => {
  return async (dispatch) => {
    try {
      const resp = await vediAPI.post(
        `v3/Usuario/AplicacionesFavoritas?idAplicacion=${numeroApp}`
      );
      const favoritosActualizados = await dispatch(getFavoriteServices());
      dispatch(setFavoritos(favoritosActualizados));
      await dispatch(fetchServicios());
      return resp.data.return.access_token;
    } catch (e) {
      console.error("[action] data tkn login error(?", e);
    }
  };
};

export const deleteFavoriteService = (numeroApp) => {
  return async (dispatch) => {
    try {
      const resp = await vediAPI.delete(
        `v3/Usuario/AplicacionesFavoritas?idAplicacion=${numeroApp}`
      );
      const favoritosActualizados = await dispatch(getFavoriteServices());
      dispatch(setFavoritos(favoritosActualizados));
      await dispatch(fetchServicios());
      return resp.data.return.access_token;
    } catch (e) {
      console.error("[action] data tkn login error(?", e);
    }
  };
};
